import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let Checkbox = class Checkbox extends Vue {
    render(h) {
        return h('a-checkbox-group', { props: {
                disabled: true,
                options: this.control.options.options ? this.control.options.options.split(';') : []
            } });
    }
};
tslib_1.__decorate([
    Prop()
], Checkbox.prototype, "control", void 0);
Checkbox = tslib_1.__decorate([
    Component({ name: 'Checkbox' })
], Checkbox);
export default Checkbox;
